import React from 'react';
import { render } from 'react-dom';
import Layout from './Layout';

(window as any).MicroLayoutInit = (id = "app", option: any = {}) => {
  render(
    <Layout
      menus={(window as any).layoutMenu[0]?.children || []}
      {...option}
    />,
    document.getElementById(id),
  )
}